<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string;
    size?: "sm" | "md" | "lg";
  }>(),
  {
    size: "md",
  }
);
</script>
<template>
  <div
    :class="[
      'font-semibold red-dot',
      size === 'sm' && 'text-sm',
      size === 'md' && 'text-base',
      size === 'lg' && 'text-lg',
    ]"
  >
    {{ title }}
  </div>
</template>
